module.exports = __webpack_public_path__ + "img/XBY.99825de3.svg";